import { Injectable } from '@angular/core';

import { AngularFireStorage } from "@angular/fire/storage";
import { AngularFirestore, AngularFirestoreCollection } from '@angular/fire/firestore';

@Injectable({
  providedIn: 'root'
})
export class GalleryService {

  private filepath = 'images/';
  private dbPath = '/images';

  objetoRef: AngularFirestoreCollection<any> = null;


  constructor(
    private storage: AngularFireStorage,
    private db:AngularFirestore
  ) {
    this.objetoRef = db.collection(this.dbPath);
  }

  public addElement(obj):void{
    this.objetoRef.add({ ...obj });
  }

  public getImages(){
    return this.storage.ref(this.filepath).listAll();
  }

  //Tarea para subir archivo
  public tareaCloudStorage(nombreArchivo: string, datos: any) {
    return this.storage.upload(this.filepath + nombreArchivo, datos);
  }

  //Referencia del archivo
  public referenciaCloudStorage(nombreArchivo: string) {
    return this.storage.ref(this.filepath + nombreArchivo);
  }

  public getAll(): AngularFirestoreCollection<any>{
    return this.db.collection(this.dbPath, ref => ref.orderBy('fecha','desc'));
  }

  // Recibe el UID de la imagen en la BD
  public deleteElement(uid, filename){
    this.storage.ref(this.filepath + filename).delete();
    return this.objetoRef.doc(uid).delete();
  }

  public async imageExist(filename:string, noimage:string){
    return await this.storage.ref(this.filepath + filename).getDownloadURL().toPromise()
    .then(  data => { return data; } )
    .catch( error => { return noimage; } );
  }


}
